import { eventLogProducer } from '@/lib/event-logger'
import { Action } from '@@/action_pb'
import Link from 'next/link'
import { useRouter } from 'next/router'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
interface IProps {
  categoryList: any[]
  category?: any
}

const QuestionList = (props: IProps) => {
  const router = useRouter()
  const [categoryList, setCategoryList] = useState([...props.categoryList])

  useEffect(() => {
    // 回填已显示的问题
    if (props.category) {
      props.categoryList.map((obj) => (obj.open = props.category.title === obj.title))
    } else {
      props.categoryList.map((obj) => (obj.open = false))
    }
    setCategoryList([...props.categoryList])
  }, [props.category, props.categoryList])

  const categoryClick = (item) => {
    item.open = !item.open
    categoryList.map((obj) => item.title !== obj.title && (obj.open = false))
    setCategoryList([...categoryList])
  }

  const eventClick = (title) => {
    eventLogProducer.push({
      action: Action.QUESTIONDETAILLINKCLICK,
      extra: { questionName: title },
    })
  }

  return (
    <QAStyle>
      <div className="category-list">
        {categoryList.map((item) => {
          return (
            <div key={item.title}>
              <a
                onClick={() => {
                  categoryClick(item)
                }}
                aria-label={item.title}
                className={item.open ? 'category category-active' : 'category'}
              >
                <p className="content">{item.title}</p>
                <img src={item.open ? '/images/faq/up.svg' : '/images/faq/down.svg'} className="right-icon" />
              </a>
              {
                <div className="question-list" style={{ display: item.open ? 'block' : 'none' }}>
                  {item.list.map((question) => {
                    return (
                      <Link key={question.slug} href={`/faq/${question.slug}`} scroll={false}>
                        <a
                          onClick={() => {
                            eventClick(question.question)
                          }}
                          aria-label={question.question}
                          className={question.slug === router.query.slug ? 'question question-active' : 'question'}
                        >
                          <p className="content">
                            {question.question}
                            {question.slug === router.query.slug && <span className="right-icon">{'  >>'}</span>}
                          </p>
                        </a>
                      </Link>
                    )
                  })}
                </div>
              }
            </div>
          )
        })}
      </div>
    </QAStyle>
  )
}

export default QuestionList

const QAStyle = styled.div`
  @media only screen and (max-width: 1000px) {
    margin-top: 62px;
    .category-list {
      width: 320px;
      margin: 0 auto;
      .category {
        border-radius: 8px;
        border: 1px solid #ccc;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 24px;
        padding: 0 24px;
        .content {
          font-size: 16px;
          font-family: Roboto-Medium, Roboto;
          font-weight: 500;
          color: #212121;
          line-height: 20px;
          width: 388px;
        }
        .right-icon {
          width: 24px;
          height: 24px;
        }
      }
      .category-active {
        background-color: #f5f5f5;
      }
      .question-active {
        .content {
          color: #1cc812;
        }
        .right-icon {
          color: #1cc812;
        }
      }
      .question-list {
        padding: 24px 16px 0px 24px;
        border-radius: 8px;
        border: solid 1px #ccc;
        width: 320px;
        margin-top: 24px;
        p {
          text-decoration: underline;
          margin: 0 0 24px 0;
          font-family: Roboto;
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: normal;
          letter-spacing: normal;
          color: #212121;
        }
      }
    }
  }
  @media only screen and (min-width: 1000px) {
    max-width: 1440px;
    margin: 0 auto;
    .category-list {
      width: 100%;
      max-width: 1440px;
      margin: 0 auto;
      .category {
        width: 476px;
        border-radius: 8px;
        border: 1px solid #ccc;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 24px;
        padding: 0 24px;
        .content {
          font-size: 16px;
          font-family: Roboto-Medium, Roboto;
          font-weight: 500;
          color: #212121;
          line-height: 20px;
          width: 388px;
        }
        .right-icon {
          width: 24px;
          height: 24px;
        }
      }
      .category-active {
        background-color: #f5f5f5;
      }
      .question-active {
        .content {
          color: #1cc812;
        }
        .right-icon {
          color: #1cc812;
        }
      }
      .question-list {
        padding: 24px 16px 0px 24px;
        border-radius: 8px;
        border: solid 1px #ccc;
        width: 476px;
        margin-top: 24px;
        p {
          text-decoration: underline;
          margin: 0 0 24px 0;
          font-family: Roboto;
          font-size: 16px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: normal;
          letter-spacing: normal;
          color: #212121;
        }
      }
    }
  }
`
